/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import querystring from 'querystring';

import AccountActions from '../../../support/AccountActions';
import { postJSON } from '../../../support/Fetch';
import { STRIPE_CLIENT_ID } from '../../../support/shared/constants/Constants';
import { createRedirectURIStripe } from '../../../support/shared/createRedirectURI';
import ensureObject from '../../../support/shared/ensureObject';
import { showError } from '../../App/AppAlert';

export function validateAuthResult(
  responseString: string,
  callback: (...args: Array<any>) => any,
) {
  let responseData = querystring.parse(responseString);
  if (responseData.error) {
    let errorMessage = String(
      responseData.error_description || responseData.error,
    );
    showError(errorMessage);
    return;
  }
  let postData = {
    code: typeof responseData.code === 'string' ? responseData.code : '',
  };
  postJSON('/oauth/stripe/validate', postData, (error, data) => {
    if (error) {
      console.error(error); // eslint-disable-line no-console
      let errorObject = ensureObject(error);
      let errorMessage = errorObject
        ? String(errorObject.message)
        : String(error);
      showError(`Unable to complete request: ${errorMessage}`);
      return;
    }
    if (data.type === 'error') {
      showError(`Unable to connect. Service returned error: ${data.message}`);
      return;
    }
    AccountActions.updateAccount(data.account);
    if (callback) {
      callback();
    }
  });
}

export function revokeAuth() {
  postJSON('/oauth/stripe/revoke', {}, (error, data) => {
    if (error) {
      console.error(error); // eslint-disable-line no-console
      let errorObject = ensureObject(error);
      let errorMessage = errorObject
        ? String(errorObject.message)
        : String(error);
      showError(`Unable to complete request: ${errorMessage}`);
    } else {
      let account = ensureObject(data.account);
      if (account) {
        AccountActions.updateAccount(account);
      }
    }
  });
}

export function getAuthURI() {
  let redirectURI = createRedirectURIStripe('stripe', window.location.host);
  return `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${STRIPE_CLIENT_ID}&scope=read_write&redirect_uri=${redirectURI}`;
}
